import { createFileRoute } from '@tanstack/react-router';

import { LabLogPanel } from '../../features/lab-log/lab-log-panel';

/**
 * `/mylab/lab-log` — S20 Lab log (E14 §2)
 *
 * My Lab 홈(S4)에서 분리된 전용 화면이다(D99) — 지난 기록 목록과 오늘 로그 편집을 한 화면에서
 * 함께 다룬다. 라우트는 얇게 둔다: 화면은 `features/lab-log`에 있다. 게이트는 부모
 * `mylab.tsx`가 맡는다.
 */
export const Route = createFileRoute('/mylab/lab-log')({
  component: LabLogPanel,
});
